import { FeedbackCategory, FeedbackCategoryItem } from '@/types/admin/feedback';

export const FEEDBACK_TEXT = {
    BUTTON: {
        ADD_MATERIAL: 'Додати матеріал',
    },
    PLACEHOLDER: {
        SEARCH_HISTORY: 'Введіть історію',
        SEARCH_REVIEWS: "Введіть відгук або ім'я",
        SEARCH_VIDEOS: "Введіть відгук або ім'я",
    },
    LIST: {
        NO_MATERIALS: 'Ще немає матеріалів',
    },
    TABS: {
        HISTORY: 'Історії',
        REVIEWS: 'Що кажуть учасники',
        VIDEOS: 'Відео відгуки',
    },
    ACTIONS: {
        REORDER: 'Змінити порядок елемента',
        EDIT: 'Редагувати',
        DELETE: 'Видалити',
        TRANSLATE: 'Перекласти',
    },
    FORM: {
        LABEL: {
            TITLE: 'Заголовок',
            STORY: 'Історія',
            NAME: "Ім'я",
            REVIEW: 'Відгук',
        },
    },
    MESSAGE: {
        FAIL_TO_FETCH_ITEMS: 'Не вдалося завантажити матеріали',
        FAIL_TO_REORDER: 'Виникла помилка, не вдалося змінити порядок елемента',
        SUCCESS_DELETE: 'Матеріал успішно видалено',
        SUCCESS_PUBLISH: 'Відгук успішно опубліковано',
        SUCCESS_UPDATE: 'Зміни успішно опубліковано',
        FAIL_TO_UPDATE: 'Виникла помилка під час збереження змін',
        SUCCESS_TRANSLATE: 'Переклад успішно збережено',
        FAIL_TO_TRANSLATE: 'Виникла помилка під час збереження перекладу',
        FAIL_TO_PUBLISH: 'Виникла помилка під час збереження',
    },
    DELETE_MODAL: {
        TITLE: 'Видалити матеріал?',
        FAIL_TO_DELETE: 'Виникла помилка під час видалення матеріалу',
    },
    ADD_HISTORY_MODAL: {
        TITLE: 'Додати історію',
        LABEL: {
            TITLE: 'Заголовок',
            STORY: 'Історія',
            PHOTO: 'Фото',
        },
        PLACEHOLDER: {
            PHOTO_LABEL: 'Додайте файл сюди',
            PHOTO_SUBTEXT: 'Розмір: 650х360',
        },
    },
    EDIT_HISTORY_MODAL: {
        TITLE: 'Редагувати історію',
    },
    ADD_VIDEO_REVIEW_MODAL: {
        TITLE: 'Додати відео відгук',
        LABEL: {
            TITLE: 'Заголовок',
            LINK: 'Посилання на відео відгук',
        },
    },
    EDIT_VIDEO_REVIEW_MODAL: {
        TITLE: 'Редагувати відео відгук',
    },
    ADD_REVIEW_MODAL: {
        TITLE: 'Додати відгук',
        LABEL: {
            AUTHOR_NAME: "Ім'я",
            TEXT: 'Відгук',
        },
    },
    EDIT_REVIEW_MODAL: {
        TITLE: 'Редагувати відгук',
    },
    PUBLISH_MODAL: {
        TITLE_NEW: 'Опублікувати новий відгук?',
    },
};

export const FEEDBACK_HISTORY_VALIDATION = {
    title: {
        min: 10,
        max: 50,
        getRequiredError: () => "Поле обов'язкове",
        getMinError: () => 'Не менше 10 символів',
        getMaxError: () => 'Не більше 50 символів',
    },
    story: {
        min: 10,
        max: 1000,
        getRequiredError: () => "Поле обов'язкове",
        getMinError: () => 'Не менше 10 символів',
        getMaxError: () => 'Не більше 1000 символів',
    },
    image: {
        cropWidth: 650,
        cropHeight: 360,
        minWidth: 650,
        minHeight: 360,
        getRequiredError: () => "Фото обов'язкове",
    },
};

export const VIDEO_REVIEW_VALIDATION = {
    title: {
        min: 5,
        max: 200,
    },
    link: {
        min: 10,
        max: 10000,
        getFormatError: () => 'Посилання має бути дійсною URL-адресою (http/https)',
    },
};

export const FEEDBACK_CATEGORIES: FeedbackCategoryItem[] = [
    { id: FeedbackCategory.HISTORY, name: FEEDBACK_TEXT.TABS.HISTORY },
    { id: FeedbackCategory.REVIEWS, name: FEEDBACK_TEXT.TABS.REVIEWS },
    { id: FeedbackCategory.VIDEOS, name: FEEDBACK_TEXT.TABS.VIDEOS },
];

const AUTHOR_NAME_MIN = 2;
const AUTHOR_NAME_MAX = 200;
const REVIEW_TEXT_MIN = 10;
const REVIEW_TEXT_MAX = 500;

export const FEEDBACK_REVIEW_VALIDATION = {
    authorName: {
        min: AUTHOR_NAME_MIN,
        max: AUTHOR_NAME_MAX,
        getRequiredError: () => "Поле обов'язкове",
        getMinError: () => `Не менше ${AUTHOR_NAME_MIN} символів`,
        getMaxError: () => `Не більше ${AUTHOR_NAME_MAX} символів`,
    },
    text: {
        min: REVIEW_TEXT_MIN,
        max: REVIEW_TEXT_MAX,
        getRequiredError: () => "Поле обов'язкове",
        getMinError: () => `Не менше ${REVIEW_TEXT_MIN} символів`,
        getMaxError: () => `Не більше ${REVIEW_TEXT_MAX} символів`,
    },
};
export const FEEDBACK_PAGINATION_LIMIT = 7;
export const FEEDBACK_SEARCH_PAGE_SIZE = 5;
